// extracted by mini-css-extract-plugin
export default {"desc":"styles_desc__ArtFL"};